import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "form--nested" };
const _hoisted_2 = { class: "table table--condensed table--form" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 0,
    class: "form__table-cell form__collection-item-button"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "form__collection-buttons" };
import { ref, watch } from 'vue';
import Icon from "../Icon.vue";
import FormLabel from "./FormLabel.vue";
import { clone, get } from "lodash";
import log from "../../services/Logger";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlTable',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {},
        disabled: { type: Boolean },
        fieldPrefix: {}
    },
    emits: [
        'change',
        'focus',
        'blur'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const innerFieldPrefix = !props.fieldPrefix
            ? props.field.name
            : props.fieldPrefix + '.' + props.field.name;
        const fieldOptions = props.field.options || {};
        const items = ref([]);
        init();
        watch(() => props.data, init);
        function init() {
            items.value = props.data ? clone(props.data) : [];
        }
        function onChange() {
            log('FieldControlTable@change', props.field.name, items.value);
            emit('change', items.value);
        }
        function onFieldChange(field, index, data) {
            items.value[index][field.name] = data;
            onChange();
        }
        function fieldData(item, field) {
            const data = get(item, field.name);
            if (data === null || data === undefined) {
                // Init empty object for nested fields
                if (field.type === 'form') {
                    item[field.name] = (field.options && field.options.collection) ? [] : {};
                    return item[field.name];
                }
            }
            return data;
        }
        function createCollectionItemFieldPrefix(index) {
            return innerFieldPrefix + '[' + index + ']';
        }
        function removeCollectionItem(item) {
            if (!fieldOptions || !fieldOptions.collection) {
                return;
            }
            const itemIndex = items.value.indexOf(item);
            items.value.splice(itemIndex, 1);
            // Reset potential validation errors for removed item
            Object.keys(props.validation.fields)
                .filter(validationField => validationField.startsWith(createCollectionItemFieldPrefix(itemIndex)))
                .forEach(validationField => props.validation.fields[validationField] = []);
            onChange();
        }
        function createCollectionItem() {
            if (!fieldOptions || !fieldOptions.collection) {
                return;
            }
            items.value.push({});
            onChange();
        }
        return (_ctx, _cache) => {
            const _component_form_group = _resolveComponent("form-group");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("table", _hoisted_2, [
                    (items.value.length > 0)
                        ? (_openBlock(), _createElementBlock("thead", _hoisted_3, [
                            _createElementVNode("tr", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.fields, (header) => {
                                    return (_openBlock(), _createElementBlock("th", {
                                        key: header.name,
                                        class: "form__table-header"
                                    }, [
                                        _createVNode(FormLabel, {
                                            form: __props.form,
                                            field: header,
                                            "field-id": __props.fieldId
                                        }, null, 8, ["form", "field", "field-id"])
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.fields, (f) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                        key: f.name,
                                        class: "form__table-cell"
                                    }, [
                                        (_openBlock(), _createBlock(_component_form_group, {
                                            form: __props.form,
                                            field: f,
                                            "field-prefix": createCollectionItemFieldPrefix(index),
                                            "hide-label": true,
                                            data: fieldData(item, f),
                                            validation: __props.validation,
                                            disabled: __props.disabled,
                                            onChange: ($event) => (onFieldChange(f, index, $event)),
                                            key: f.name
                                        }, null, 8, ["form", "field", "field-prefix", "data", "validation", "disabled", "onChange"]))
                                    ]));
                                }), 128)),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                (!_unref(fieldOptions).disabled && _unref(fieldOptions).collectionAddRemove !== false)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                                        _createElementVNode("a", {
                                            onClick: _withModifiers(($event) => (removeCollectionItem(item)), ["prevent"]),
                                            class: "button button--small",
                                            href: ""
                                        }, [
                                            _createVNode(Icon, { name: "trash-alt" })
                                        ], 8, _hoisted_5)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128)),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        (!_unref(fieldOptions).disabled && _unref(fieldOptions).collectionAddRemove !== false)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                                _createElementVNode("td", _hoisted_7, [
                                    _createElementVNode("a", {
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (createCollectionItem()), ["prevent"])),
                                        class: "button button--small",
                                        href: ""
                                    }, [
                                        _createVNode(Icon, { name: "plus" })
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
